<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="box">
    <div class="container" @click="downloadHide">
      <banner @banner-event="downloadShow" />
      <div class="copy" v-if="copyText">
         <h3> {{ $t('share.icode')}} </h3>
        <div class="copy-container">
          <div class="text-display">{{ copyText }}</div>
          <button class="copy-btn" @click="handleCopy">
            {{ copied ? $t('share.success'): $t('share.copy') }}
          </button>
        </div>
        <p class="copy-notice"> {{ $t('share.notice')}} </p>
      </div>
      <describe />
      <div class="highlights" >
        <img src="../assets/bottom.png" v-if="currentLocale === 'zh'"/>
        <img src="../assets/bottomEn.png" v-else/>
      </div>
    </div>
      <com-fotter></com-fotter>
    <down-list v-if="isBtnShow"></down-list>
  </div>
</template>

<script>
import banner from '@/components/banner.vue'
import downList from '@/components/downList.vue'
import describe from '@/components/describe.vue'
import comFotter from '@/components/fotter.vue'
export default {
  components: { banner, downList, describe, comFotter },
  data () {
    return {
      isBtnShow: false,
      copyText: '',
      copied: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  mounted () {
    // 确保DOM完全渲染后初始化
    this.copyText = this.$route.params.id
    if (!this.$route.params.id) {
      this.isBtnShow = true
    }
  },
  methods: {
    downloadShow () {
      if (!this.isBtnShow) this.isBtnShow = true
    },
    downloadHide () {
      if (this.isBtnShow) this.isBtnShow = false
    },
    async handleCopy () {
      try {
        // 尝试使用现代 Clipboard API
        await navigator.clipboard.writeText(this.copyText)
        this.showCopiedFeedback()
      } catch (err) {
        // 降级到传统方法
        this.fallbackCopy()
      }
    },
    fallbackCopy () {
      const textarea = document.createElement('textarea')
      textarea.value = this.copyText
      textarea.style.position = 'fixed' // 避免滚动到页面底部
      document.body.appendChild(textarea)
      textarea.select()

      try {
        document.execCommand('copy')
        this.showCopiedFeedback()
      } catch (err) {
        console.error('复制失败:', err)
        alert('复制失败，请手动选择文本并复制')
      }

      document.body.removeChild(textarea)
    },
    showCopiedFeedback () {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 5000)
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 10px 5%;
}
.copy {
  margin: 30px auto;
  padding: 10px 5px;
}

.copy h3{font-size: 18px;font-weight: bold;}

.copy-notice {
  font-size: 16px;
  line-height: 25px;
  color: #ff9800;
}

.copy-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
}

.text-display {
  color: #000;
}

.copy-btn {
  padding: 8px 16px;
  background: #3278FD;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

</style>
